import { AssetClasses } from "../../simulations/models/assetClasses";

export class TradeRestriction {
  public id: number;
  public portfolio;
  public security;
  public noBuy: boolean;
  public noSell: boolean;
  public percentageOfPortfolio: boolean;
  public minPortfolio;
  public maxPortfolio;

  public dateCreated: string;
  public createdBy;
  public enabled: boolean;
  public assetClass;

  public restriction(): string {
    if (this.noBuy && this.noSell) {
      return "Can not be bought or sold";
    }

    if (this.noBuy) {
      return "Can not be bought";
    }

    if (this.noSell) {
      return "Can not be sold";
    }

    if (this.percentageOfPortfolio) {
      return `Must be between ${this.minPortfolio}% and ${this.maxPortfolio}% of overall portfolio`;
    }

    return "No trade restriction";
  }

  public type(): string {
    if (this.assetClass) {
      return `Asset Class - ${this.assetClass.name}`;
    }
    if (this.security) {
      return `Security - ${this.security.name}`;
    }
    return "Unknown";
  }

  public constructor(tradeRestrictionDTO?: any) {
    if (tradeRestrictionDTO != null) {
      this.id = tradeRestrictionDTO.id;
      this.portfolio = tradeRestrictionDTO.portfolio;
      this.security = tradeRestrictionDTO.security;
      this.noBuy = tradeRestrictionDTO.noBuy;
      this.noSell = tradeRestrictionDTO.noSell;
      this.percentageOfPortfolio = tradeRestrictionDTO.percentageOfPortfolio;
      this.minPortfolio = tradeRestrictionDTO.minPortfolio;
      this.maxPortfolio = tradeRestrictionDTO.maxPortfolio;
      this.dateCreated = tradeRestrictionDTO.dateCreated;
      this.createdBy = tradeRestrictionDTO.createdBy;
      this.enabled = tradeRestrictionDTO.enabled;
      this.assetClass = tradeRestrictionDTO.assetClass;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/trading/models/tradeRestriction.ts